import script from "./CaskTabsVertical.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskTabsVertical.vue?vue&type=script&setup=true&lang=js"

import "./CaskTabsVertical.vue?vue&type=style&index=0&id=edfe0ce8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edfe0ce8"]])

export default __exports__